import BaseFormItem from "../BaseFormItem";
import { descriptorPropTypes } from "lib/common/descriptorcontrols/formhelpers";
import PropTypes from "prop-types";
import Control from "lib/common/descriptorcontrols/ChoiceField/label";
import React from "react";
import entityFieldMetaStore from "data/meta/entityFieldMetaStore";

const inflateValue = (v, c) =>
    v instanceof Array
        ? ArmusScript["toOptionLabel(Array<String>,String)"](v, c).join(", ")
        : ArmusScript["toOptionLabel(String,String)"](v, c);

export class ChoiceFieldlabel extends BaseFormItem {
    render() {
        const {activeRecord, descriptor} = this.props;
        const info = entityFieldMetaStore.getInfo(activeRecord.entityKey, descriptor.key);
        return <Control {...this.getPlumbingProps()}
                        choiceKey={info.choiceKey}
                        value={inflateValue(activeRecord.get(descriptor.key), info.choiceKey)}
                        enabled={activeRecord.isFieldEnabled(descriptor.key)}
        />;
    }
}

ChoiceFieldlabel.propTypes = {
    ...ChoiceFieldlabel.propTypes,
    descriptor: PropTypes.shape(descriptorPropTypes()),
};

export default ChoiceFieldlabel;



// WEBPACK FOOTER //
// ./app/lib/dataentry/lib/dataentryform/formitems/ChoiceField/label.js